
import axios from 'axios'

export const uploadFile = async (url: string, file: any, headers: any, type: string) => {

    const formData = new FormData()

    formData.append('image', file)
    formData.append('type', type)

    return await axios.post(url, formData, { headers: {
        ...headers,
        'Content-Type': 'multipart/form-data'
    } })
}
